import Swiper from 'swiper/bundle'

export default {
  init() {
    // JavaScript to be fired on all pages
    //
    let mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
    mapboxgl.accessToken = 'pk.eyJ1IjoiYmNuY28iLCJhIjoiY2wxeHEyNm5xMDBvOTNjcmE4bHRzZHJyeiJ9.d4ATsz8VW2qpcDG-Ic9Sbg';

    $(window).scroll(function () {
        scroll = $(window).scrollTop();
        posHeader();
    });


    // HEADER
    $('.js_toggle-menu').on('click', function() {
      $(this).toggleClass('close');
      $('body').toggleClass('menu-active');
    });


    let scroll;
    let position = $(window).scrollTop();
    let keepHeaderVisible = false;
    let headerSticky = 0;
    let $header = $('#header');
    let headerHeight;

    function posHeader() {
      headerHeight = $header.outerHeight(true);

      if (scroll == 0) {
        $('body').removeClass('scroll-up scroll-down');
      } else if (scroll > position) {
        $('body').addClass('scroll-down').removeClass('scroll-up');
      } else {
        $('body').addClass('scroll-up').removeClass('scroll-down');
      }

      if ($(document).width() > 1024) {
        if (scroll > position) {
          // Scroll down
          if (scroll > headerHeight) {
            // Cache le header
            headerSticky = headerHeight;
            $header.addClass('transition');
          } else {
            if (!keepHeaderVisible) {
              // Cache le header progressivement suivant le scroll
              headerSticky = scroll;
              $header.removeClass('transition');
            }
          }
        } else {
          // Scroll Up
          if (scroll > headerHeight) {
            // Affiche le header
            headerSticky = 0;
            $header.addClass('transition');
            keepHeaderVisible = true; // Garde le header visible jusqu'en haut de page
          } else if (keepHeaderVisible) {
            headerSticky = 0;
            $header.addClass('transition');
          } else {
            // Affiche le header progressivement suivant le scroll
            headerSticky = scroll;
            $header.removeClass('transition');
          }
        }
        if (scroll <= 0) {
          headerSticky = 0;
          keepHeaderVisible = false;
        }

        $('#header .header-wrapper').css('transform', 'translateY(-' + headerSticky + 'px)');

        position = scroll;
      } else {
        $('#header .header-wrapper').css('transform', '');
      }
    }
    posHeader();


    // FOOTER
    $('.js_footer-btn-scroll').on('click', function() {
        $('html,body').stop().animate({
            scrollTop: 0,
        }, 1500);
    });


    // MODULE CONTACT
    if($('#map-module-contact').length > 0) {
      let lat = $('#map-module-contact').data('lat');
      let lng = $('#map-module-contact').data('lng');
      console.log('TEST', lat, lng);
      if (lat && lng) {
        const mapContact = new mapboxgl.Map({
          container: 'map-module-contact',
          style: 'mapbox://styles/mapbox/streets-v11',
          center: [lng, lat],
          zoom: 16,
        });
        new mapboxgl.Marker({ color: '#0E2F3E' })
          .setLngLat([lng, lat])
          .addTo(mapContact);
      }
    }


    // MODULE TEAM
    $('.js_open-popin').on('click', function() {
      $('.popin-wrapper .popin-content').append($(this).next('.desc-popin').html());
      $('.popin-wrapper').show(0).addClass('active');
    });
    $('.popin-wrapper, .js_close-popin').on('click', function (e) {
        if (e.target !== this) {
            return;
        }
        $('.popin-wrapper').removeClass('active');
        setTimeout(function() {
        $('.popin-wrapper').hide(0);
          $('.popin-wrapper .popin-content').text('');
        }, 600);
    });



    // SLIDER TEAM
    if ($('.js_slider-team .item').length > 1) {
      console.log('init slider team');
      new Swiper('.js_slider-team', {
        navigation: {
          nextEl: '.js_slider-team-btn-next',
          prevEl: '.js_slider-team-btn-prev',
        },
      });
    }


    // SLIDER LOGOS
    new Swiper('.js_slider-logos', {
      loop: true,
      speed: 750,
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: '.js_slider-logos-btn-next',
        prevEl: '.js_slider-logos-btn-prev',
      },
      breakpoints: {
        481: {
          slidesPerView: 3,
        },
        601: {
          slidesPerView: 4,
        },
        961: {
          slidesPerView: 5,
          spaceBetween: 26,
        },
        1025: {
          slidesPerView: 6,
        },
      },
    });
    
    
    // SLIDER REVIEWS
    new Swiper('.js_slider-reviews', {
      loop: true,
      speed: 750,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.js_slider-reviews-btn-next',
        prevEl: '.js_slider-reviews-btn-prev',
      },
    });


    // Blur on click
    $('a, button, input[type=\'submit\'], .btn').on('click', function() {
        $(this).blur();
    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
